import { render, staticRenderFns } from "./chatWithGPT.vue?vue&type=template&id=1bb54d7d&scoped=true"
import script from "./chatWithGPT.vue?vue&type=script&lang=js"
export * from "./chatWithGPT.vue?vue&type=script&lang=js"
import style0 from "./chatWithGPT.vue?vue&type=style&index=0&id=1bb54d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb54d7d",
  null
  
)

export default component.exports